import { gql } from "graphql-request"

const everscale = {
    name: 'everscale',
    title: 'Everscale',
    currency: 'EVER',
    check: false,
    regexp: '([\\w]|^)(-?[0-9]\\d*(\\.\\d+)?:[0-9a-fA-F]{64})([\\W]|$)',
    noregxp: [
        '([\\W]|^)(bnb[0-9a-z]{2})([\\W]|$)',
        '([\\W]|^)(T[\\w]{2})([\\W]|$)',
        '([\\W]|^)(bnb[0-9a-z]{2)([\\W]|$)',
        '([\\W]|^)((cosmos1|terra1|tcro1|tcrocncl1)[a-zA-HJ-NP-Z0-9]{38,70})([\\W]|$)',
    ],
    query: gql`query ($address: String!) {
        everscale(network: everscale) {
            address(address: {is: $address}) {
                balance {
                    balance: value
                    balance_usd: value(in: USD)
                }
            }
            ins: transfers(transferReceiver: {is: $address}) {
                count: count(uniq: txs)
                min_date: minimum(of: date)
                max_date: maximum(of: date)
            }
            currencyIn: transfers(transferReceiver: {is: $address}) {
                count
                currency {
                    symbol
                    address
                    tokenId
                }
            }
            outs: transfers(transferSender: {is: $address}) {
                count: count(uniq: txs)
                min_date: minimum(of: date)
                max_date: maximum(of: date)
            }
            currencyOut: transfers(transferSender: {is: $address}) {
                count
                currency {
                    symbol
                    address
                    tokenId
                }
            }
        }
    }`,
    checkAddress:
        '-1:04f64c6afbff3dd10d8ba6707790ac9670d540f37a9448b0337baa6a5a92acac',
}
export { everscale }
